/**
 * Platform functional permissions returned by the productivity API's
 * `myFunctionalPermissions` query. Keys must match the backend
 * FunctionalPermission enum. Named per entity type (plural) — these grant
 * access to the whole type, not to individual records.
 */
export enum FunctionalPermission {
  ManageUsers = 'MANAGE_USERS',
  ManageRoles = 'MANAGE_ROLES',
  ManageUserGroups = 'MANAGE_USER_GROUPS',
  ManagePermissions = 'MANAGE_PERMISSIONS',
  ManageConfig = 'MANAGE_CONFIG',
  ManageIntegrations = 'MANAGE_INTEGRATIONS',
  ViewAuditLog = 'VIEW_AUDIT_LOG',
  ViewOrgChart = 'VIEW_ORG_CHART',
  ManageOrgChart = 'MANAGE_ORG_CHART',
  ViewJobProfile = 'VIEW_JOB_PROFILE',
  ManageJobProfile = 'MANAGE_JOB_PROFILE',
  ManagePosition = 'MANAGE_POSITION',
  ManageDepartment = 'MANAGE_DEPARTMENT',

  ViewSurveys = 'VIEW_SURVEY',
  ManageSurveys = 'MANAGE_SURVEY',

  ViewOkr = 'VIEW_OKR',
  ManageOkr = 'MANAGE_OKR',
  ViewTask = 'VIEW_TASK',
  ManageTask = 'MANAGE_TASK',
  ViewHabit = 'VIEW_HABIT',
  ManageHabit = 'MANAGE_HABIT',
  ViewActionPlan = 'VIEW_ACTION_PLAN',
  ManageActionPlan = 'MANAGE_ACTION_PLAN',
  ManageProductivityModel = 'MANAGE_PRODUCTIVITY_MODEL',

  ViewOneOnOne = 'VIEW_ONE_ON_ONE',
  ManageOneOnOne = 'MANAGE_ONE_ON_ONE',
  ViewMeeting = 'VIEW_MEETING',
  ManageMeeting = 'MANAGE_MEETING',
  ViewPraise = 'VIEW_PRAISE',
  ManagePraise = 'MANAGE_PRAISE',
  ViewFeedback = 'VIEW_FEEDBACK',
  ManageFeedback = 'MANAGE_FEEDBACK',
  ViewAnnouncement = 'VIEW_ANNOUNCEMENT',
  ManageAnnouncement = 'MANAGE_ANNOUNCEMENT',
  ViewCommunity = 'VIEW_COMMUNITY',
  ManageCommunity = 'MANAGE_COMMUNITY',

  ViewReview = 'VIEW_REVIEW',
  ManageReview = 'MANAGE_REVIEW',
  ViewSkill = 'VIEW_SKILL',
  ManageSkill = 'MANAGE_SKILL',
  ViewGamification = 'VIEW_GAMIFICATION',
  ManageGamification = 'MANAGE_GAMIFICATION',

  ViewContent = 'VIEW_CONTENT',
  ManageContent = 'MANAGE_CONTENT',
  ViewSession = 'VIEW_SESSION',
  ManageSession = 'MANAGE_SESSION',
  ViewJourney = 'VIEW_JOURNEY',
  ManageJourney = 'MANAGE_JOURNEY',
  ViewEvent = 'VIEW_EVENT',
  ManageEvent = 'MANAGE_EVENT',

  ViewReport = 'VIEW_REPORT',
  ManageReport = 'MANAGE_REPORT',

  ManageOnboarding = 'MANAGE_ONBOARDING',
  ManageSubscription = 'MANAGE_SUBSCRIPTION',

  ManageAcademy = 'MANAGE_ACADEMY',
  ManageHomepage = 'MANAGE_HOMEPAGE',
  ManageAuth = 'MANAGE_AUTH',
  ManageSubaccounts = 'MANAGE_SUBACCOUNTS',

  ViewBookmarks = 'VIEW_BOOKMARKS',
  ManageAssignments = 'MANAGE_ASSIGNMENTS',
}
